import { Button, EmptyState, Stack } from "@shopify/polaris";
import styles from "../ActionTable.module.css";

const EmptyPage = ({ ...props }) => {

  return (
    <EmptyState image={props.image ? props.image : ''}>
      <Stack spacing="loose" vertical>
        {props.img && <img src={props.img} width={50} height={50} alt=""></img>}
        <p>{props.message ? props.message : ''}</p>
        {props.wait ? <p className={styles['wait_message']}>{props.wait}</p> : null}
        {(props.handleSync || props.handleCreateAction) &&
          <Button
            icon={props.icon && props.icon}
            onClick={props.handleSync ? props.handleSync : props.handleCreateAction}
            primary
          >
            {props.handleSync ? 'Sync' : 'Create new action'}
          </Button>
        }
      </Stack>
    </EmptyState>
  )
}

export default EmptyPage;
